import {
  convertToCamelCase,
  getFormattedDate,
  getFormattedDateWithTime,
} from "components/common/Utility";
import {
  isErrorFieldEditable,
  getTooltipText,
  isErrorFieldHighlighted,
} from "./utils";
export const UploadPOcolumnDefs = [
  {
    headerName: "Supplier Site ID",
    field: "suppliedSiteId",
    type: "numericColumn",
    editable: (params) => isErrorFieldEditable(params, "suppliedSiteId"),
    tooltipValueGetter: (params) => getTooltipText(params, "suppliedSiteId"),
    cellClass: (params) => isErrorFieldHighlighted(params, "suppliedSiteId"),
    cellStyle: { textAlign: "right" },
  },
  {
    headerName: "Destination Location",
    field: "destinationLocation",
    type: "numericColumn",
    editable: (params) => isErrorFieldEditable(params, "destinationLocation"),
    tooltipValueGetter: (params) =>
      getTooltipText(params, "destinationLocation"),
    cellClass: (params) =>
      isErrorFieldHighlighted(params, "destinationLocation"),
    cellStyle: { textAlign: "right" },
  },
  {
    headerName: "Order Date",
    field: "orderDate",
    editable: (params) => isErrorFieldEditable(params, "orderDate"),
    tooltipValueGetter: (params) => getTooltipText(params, "orderDate"),
    cellClass: (params) => isErrorFieldHighlighted(params, "orderDate"),
    cellStyle: { textAlign: "right" },
    headerClass: "right-aligned-header",
  },
  {
    headerName: "Delivery Date",
    field: "deliveryDate",
    editable: (params) => isErrorFieldEditable(params, "deliveryDate"),
    tooltipValueGetter: (params) => getTooltipText(params, "deliveryDate"),
    cellClass: (params) => isErrorFieldHighlighted(params, "deliveryDate"),
    cellStyle: { textAlign: "right" },
    headerClass: "right-aligned-header",
  },
  {
    headerName: "Pin",
    field: "packid",
    type: "numericColumn",
    editable: (params) => isErrorFieldEditable(params, "packid"),
    tooltipValueGetter: (params) => getTooltipText(params, "packid"),
    cellClass: (params) => isErrorFieldHighlighted(params, "packid"),
    cellStyle: { textAlign: "right" },
  },
  {
    headerName: "Order Quantity (cases)",
    field: "orderQuantityCases",
    type: "numericColumn",
    editable: (params) => isErrorFieldEditable(params, "orderQuantityCases"),
    tooltipValueGetter: (params) =>
      getTooltipText(params, "orderQuantityCases"),
    cellClass: (params) =>
      isErrorFieldHighlighted(params, "orderQuantityCases"),
    cellStyle: { textAlign: "right" },
  },
  {
    headerName: "Order Quantity (pallets)",
    field: "orderQuantityPallets",
    type: "numericColumn",
    editable: (params) => isErrorFieldEditable(params, "orderQuantityPallets"),
    tooltipValueGetter: (params) =>
      getTooltipText(params, "orderQuantityPallets"),
    cellClass: (params) =>
      isErrorFieldHighlighted(params, "orderQuantityPallets"),
    cellStyle: { textAlign: "right" },
  },
  {
    headerName: "Handball",
    field: "handball",
    editable: (params) => isErrorFieldEditable(params, "handball"),
    tooltipValueGetter: (params) => getTooltipText(params, "handball"),
    cellClass: (params) => isErrorFieldHighlighted(params, "handball"),
    cellStyle: { textAlign: "left" },
  },
  {
    headerName: "Import",
    field: "import",
    editable: (params) => isErrorFieldEditable(params, "import"),
    tooltipValueGetter: (params) => getTooltipText(params, "import"),
    cellClass: (params) => isErrorFieldHighlighted(params, "import"),
    cellStyle: { textAlign: "left" },
  },
];

export const splitPOColumnDefs = [
  {
    headerName: "",
    children: [
      {
        headerName: "Pin",
        field: "packId",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        cellStyle: { textAlign: "right" },
        minWidth: 120,
        maxWidth: 140,
        pinned: "left",
        filter: false,
        suppressNavigable: true,
      },
      {
        headerName: "Description",
        field: "itemDescription",
        headerClass: "center-aligned-header",
        cellStyle: { textAlign: "left" },
        width: 300,
        pinned: "left",
        filter: false,
        suppressNavigable: true,
      },
      {
        headerName: "Pack Size",
        field: "packSize",
        type: "numericColumn",
        headerClass: "centered-header",
        cellStyle: { textAlign: "right" },
        minWidth: 80,
        maxWidth: 100,
        pinned: "left",
        filter: false,
        suppressNavigable: true,
      },
      {
        headerName: "Category",
        field: "category",
        headerClass: "centered-header",
        cellStyle: { textAlign: "left" },
        sortable: true,
        filter: true,
        minWidth: 120,
        maxWidth: 140,
        pinned: "left",
        suppressNavigable: true,
      },
      {
        headerName: "Original Qty (cases)",
        field: "quantityOrdered",
        type: "numericColumn",
        headerClass: "centered-header",
        cellStyle: { textAlign: "right" },
        minWidth: 80,
        maxWidth: 90,
        pinned: "left",
        filter: false,
        suppressNavigable: true,
      },
      {
        headerName: "Original Qty (pallets)",
        field: "palletQuantity",
        type: "numericColumn",
        headerClass: "centered-header",
        cellStyle: { textAlign: "right" },
        minWidth: 80,
        maxWidth: 90,
        pinned: "left",
        filter: false,
        suppressNavigable: true,
      },
    ],
  },
];

//Create Input Screen Supply PO
export const createInputColumnDefs = (isMobile = false) => [
  {
    headerName: "",
    children: [
      {
        headerName: "",
        field: "products",
        pinned: isMobile ? null : "left",
        minWidth: 110,
        maxWidth: 115,
        filter: false,
        cellStyle: { textAlign: "left" },
        headerClass: "center-aligned-header",
        cellRenderer: (params) => {
          const { isByProduct, isDoNotOrderProduct, isSingleStack } =
            params.data;
          return (
            <div className="columnBadge">
              {isByProduct && <span className="badge badge-by">BY </span>}
              {isDoNotOrderProduct && (
                <span>DNO </span>
              )}
              {isSingleStack && <span className="badge badge-ss">SS </span>}
            </div>
          );
        },
        tooltipValueGetter: (params) => {
          const { isByProduct, isDoNotOrderProduct, isSingleStack } =
            params.data;
          const tooltips = [];
          if (isByProduct) tooltips.push("BY Product");
          if (isDoNotOrderProduct) tooltips.push("Do Not Order Product");
          if (isSingleStack) tooltips.push("Single Stack");
          return tooltips.length > 0 ? tooltips.join(" | ") : "";
        },
        tooltipComponentParams: { style: { whiteSpace: "pre-line" } },
        suppressNavigable: true,
      },
      {
        headerName: "PIN",
        field: "packId",
        pinned: isMobile ? null : "left",
        minWidth: 90,
        maxWidth: 95,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "center-aligned-header",
        suppressNavigable: true,
      },
      {
        headerName: "Description",
        field: "itemDescription",
        pinned: isMobile ? null : "left",
        minWidth: 300,
        maxWidth: 305,
        filter: false,
        tooltipField: "description",
        cellStyle: { textAlign: "left" },
        headerClass: "center-aligned-header",
        suppressNavigable: true,
      },
      {
        headerName: "Pack Size",
        field: "packSize",
        pinned: isMobile ? null : "left",
        minWidth: 60,
        maxWidth: 65,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "centered-header",
        suppressNavigable: true,
      },
      {
        headerName: "Category",
        field: "category",
        sortable: true,
        pinned: isMobile ? null : "left",
        minWidth: 100,
        maxWidth: 105,
        cellStyle: { textAlign: "left" },
        filter: "agTextColumnFilter",
        filterParams: {
          filterOptions: ["contains"],
          maxNumConditions: 1,
        },
        headerClass: "center-aligned-header",
        suppressNavigable: true,
      },
      {
        headerName: "SOH",
        field: "stockOnHand",
        pinned: isMobile ? null : "left",
        minWidth: 50,
        maxWidth: 55,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "center-aligned-header",
        suppressNavigable: true,
      },
      {
        headerName: "SOO",
        field: "stockOnOrder",
        pinned: isMobile ? null : "left",
        minWidth: 50,
        maxWidth: 55,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "center-aligned-header",
        suppressNavigable: true,
      },
      {
        headerName: "Avail Cover (days)",
        field: "availableCover",
        pinned: isMobile ? null : "left",
        minWidth: 75,
        maxWidth: 80,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "centered-header",
        valueFormatter: (params) => (params.value === -1 ? "NA" : params.value),
        suppressNavigable: true,
      },
      {
        headerName: "Ave Ship (days)",
        field: "averageShipment",
        pinned: isMobile ? null : "left",
        minWidth: 50,
        maxWidth: 55,
        filter: false,
        cellStyle: { textAlign: "right" },
        headerClass: "centered-header",
        suppressNavigable: true,
      },
    ],
  },
];

export const PoEnquirycolumnDefs = [
  {
    headerName: "PIN",
    field: "packId",
    type: "numericColumn",
    minWidth: 70,
    maxWidth: 80,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "Description",
    field: "itemDescription",
    tooltipField: "Description",
    width: 200,
    cellStyle: { textAlign: "left" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "Pack Size",
    field: "packSize",
    type: "numericColumn",
    minWidth: 40,
    maxWidth: 50,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Category",
    field: "category",
    sortable: true,
    type: "numericColumn",
    headerClass: "center-aligned-header",
    minWidth: 90,
    maxWidth: 100,
    filter: true,
    cellStyle: { textAlign: "left" },
    suppressNavigable: true,
  },
  {
    headerName: "SOH",
    field: "stockOnHand",
    type: "numericColumn",
    minWidth: 40,
    maxWidth: 50,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "SOO",
    field: "stockOnOrder",
    type: "numericColumn",
    minWidth: 40,
    maxWidth: 50,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "center-aligned-header",
    suppressNavigable: true,
  },
  {
    headerName: "Avail Cover (days)",
    field: "availableCover",
    type: "numericColumn",
    minWidth: 40,
    maxWidth: 50,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
    valueFormatter: (params) => {
      return params.value === -1 ? "NA" : params.value;
    },
  },
  {
    headerName: "Ave Ship (days)",
    field: "averageShipment",
    type: "numericColumn",
    minWidth: 40,
    maxWidth: 50,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Order Qty (Cases)",
    field: "quantityOrdered",
    type: "numericColumn",
    minWidth: 80,
    maxWidth: 100,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
  {
    headerName: "Order Qty (Pallets)",
    field: "palletQuantity",
    type: "numericColumn",
    minWidth: 80,
    maxWidth: 100,
    filter: false,
    cellStyle: { textAlign: "right" },
    headerClass: "centered-header",
    suppressNavigable: true,
  },
];

export const PoLifecycleColumns = [
  {
    headerName: "User",
    field: "updatedBy",
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    minWidth: 300,
    maxWidth: 350,
    suppressNavigable: true,
    tooltipValueGetter: (params) => params.data.updatedBy,
  },
  {
    headerName: "Action",
    valueGetter: (params) => {
      return convertToCamelCase(params.data.status);
    },
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    minWidth: 70,
    maxWidth: 90,
    suppressNavigable: true,
  },
  {
    headerName: "Reason",
    field: "reasonCodeName",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    minWidth: 200,
    maxWidth: 200,
    suppressNavigable: true,
  },
  {
    headerName: "Status",
    valueGetter: (params) => {
      return convertToCamelCase(params.data.status);
    },
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    minWidth: 70,
    maxWidth: 90,
    suppressNavigable: true,
  },
  {
    headerName: "Timestamp",
    valueGetter: (params) => {
      return getFormattedDateWithTime(params.data.updatedAt);
    },
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "Delivery Date",
    valueGetter: (params) => {
      return getFormattedDate(params.data.deliveryDate);
    },
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "Handball",
    field: "isHandball",
    valueGetter: (params) => {
      return params.data.isHandball ? "Yes" : "No";
    },
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    suppressNavigable: true,
  },
];

export const PoLifecycleItemLevelAuditColumns = [
  {
    headerName: "PIN",
    field: "packId",
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "Description",
    field: "itemDescription",
    type: "numericColumn",
    minWidth: 370,
    maxWidth: 400,
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    tooltipValueGetter: (params) => params.data.itemDescription,
    suppressNavigable: true,
  },
  {
    headerName: "User",
    field: "updatedBy",
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    tooltipValueGetter: (params) => params.data.updatedBy,
    suppressNavigable: true,
  },
  {
    headerName: "Action",
    valueGetter: (params) => {
      return convertToCamelCase(params.data.status);
    },
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "left" },
    suppressNavigable: true,
  },
  {
    headerName: "Timestamp",
    valueGetter: (params) => {
      return getFormattedDateWithTime(params.data.updatedAt);
    },
    type: "numericColumn",
    headerClass: "center-aligned-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "Orig Order Qty (Cases)",
    field: "originalQuantityOrderedInCases",
    type: "numericColumn",
    headerClass: "centered-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "Orig Order Qty (Pallets)",
    field: "originalPalletQuantity",
    type: "numericColumn",
    headerClass: "centered-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "New Order Qty (Cases)",
    field: "newQuantityOrderedInCases",
    type: "numericColumn",
    headerClass: "centered-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
  {
    headerName: "New Order Qty (Pallets)",
    field: "newPalletQuantity",
    type: "numericColumn",
    headerClass: "centered-header",
    cellStyle: { textAlign: "right" },
    suppressNavigable: true,
  },
];

export const amendPOColumnDefs = [
  {
    headerName: "",
    children: [
      {
        headerName: "",
        field: "selected",
        cellEditor: "agCheckboxCellEditor",
        editable: true,
        minWidth: 20,
        maxWidth: 30,
      },
      {
        headerName: "PIN",
        field: "packId",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 100,
        maxWidth: 120,
        cellStyle: { textAlign: "right" },
        suppressNavigable: true,
      },
      {
        headerName: "Description",
        field: "itemDescription",
        width: 300,
        headerClass: "center-aligned-header",
        cellStyle: { textAlign: "left" },
        suppressNavigable: true,
      },
      {
        headerName: "Pack Size",
        field: "packSize",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 60,
        maxWidth: 70,
        cellStyle: { textAlign: "right" },
        suppressNavigable: true,
      },
      {
        headerName: "Category",
        field: "category",
        sortable: true,
        minWidth: 100,
        maxWidth: 120,
        headerClass: "center-aligned-header",
        filter: "agTextColumnFilter",
        cellStyle: { textAlign: "left" },
        filterParams: {
          filterOptions: ["contains"],
          suppressAndOrCondition: true,
          maxNumConditions: 1,
        },
        suppressNavigable: true,
      },
      {
        headerName: "SOH",
        field: "stockOnHand",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 50,
        maxWidth: 60,
        cellStyle: { textAlign: "right" },
        suppressNavigable: true,
      },
      {
        headerName: "SOO",
        field: "stockOnOrder",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 50,
        maxWidth: 60,
        cellStyle: { textAlign: "right" },
        suppressNavigable: true,
      },
      {
        headerName: "Avail Cover (days)",
        field: "availableCover",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 70,
        maxWidth: 80,
        cellStyle: { textAlign: "right" },
        valueFormatter: (params) => {
          return params.value === -1 ? "NA" : params.value;
        },
        suppressNavigable: true,
      },
      {
        headerName: "Ave Ship (days)",
        field: "averageShipment",
        type: "numericColumn",
        headerClass: "center-aligned-header",
        minWidth: 70,
        maxWidth: 80,
        cellStyle: { textAlign: "right" },
        suppressNavigable: true,
      },
    ],
  },
];
